import React from 'react'
import './aboutus.scss'

const AboutUs = () => {
    return (
        <div className="container-aboutus">
            <h3>Meet Us at Our Store :)</h3>
        </div>
    )
}

export default AboutUs
